// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/nav Components/Applied-Interns.js
import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './applied-interns.module.css';

const AppliedInterns = () => {
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);

    const handleJobClick = (jobId) => {
        navigate(`/job-details/${jobId}`);
    };
    useEffect(() => {
        const fetchAppliedJobs = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }

                const response = await axios.get('/api/jobs/applied-interns', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setAppliedJobs(response.data);
                // console.log('Applied jobs:fe1', response.data);
            } catch (error) {
                console.error('Error fetching applied jobs:', error);
                setNotification('Error fetching applied jobs. Please try again.');
            }
        };

        fetchAppliedJobs();
    }, [navigate]);

    const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <>
        <NavHeader />
        <div className={styles.appliedInternsContainer}>
            {notification && (
                <div className={styles.notification}>
                    <p>{notification}</p>
                    <button 
                        onClick={handleCloseNotification}
                        className={styles.closeButton}
                    >
                        ×
                    </button>
                </div>
            )}
            
            <h2 className={styles.pageTitle}>Applied Jobs</h2>
            
            <div className={styles.jobsList}>
                {appliedJobs.map(job => (
                    <div 
                        key={job._id} 
                        className={styles.jobCard}
                        onClick={() => handleJobClick(job.jobId._id)}
                    >
                        <div className={styles.jobHeader}>
                            <img 
                                src={job.jobId?.company.logo 
                                    ? job.jobId.company.logo.replace('/upload/', '/upload/w_192,h_200,c_fill/') 
                                    : '/default-profile.png'
                                }
                                alt={`${job.jobId?.company.name} logo`} 
                                className={styles.companyLogo} 
                            />
                            <div className={styles.jobTitleSection}>
                                <h3 className={styles.jobTitle}>{job.jobId?.title}</h3>
                                <p className={styles.companyName}>{job.jobId?.company.name}</p>
                            </div>
                            <div className={styles.statusBadge}>
                                <span className={`${styles.status} ${styles[job.status?.toLowerCase()]}`}>
                                    {job.status}
                                </span>
                            </div>
                        </div>
                        
                        <div className={styles.jobDetails}>
                            <p className={styles.jobDescription}>
                                {job.jobId?.description?.split('\n').slice(0, 2).join(' ')}...
                            </p>
                            <p className={styles.jobLocation}>
                                <span className={styles.label}>Location:</span> {job.jobId?.location}
                            </p>
                            <p className={styles.jobId}>
                                <span className={styles.label}>Job ID:</span> {job._id}
                            </p>
                        </div>
                        
                        {job.jobId?.rejectionReasons?.length > 0 && (
                            <div className={styles.rejectionSection}>
                                <h4 className={styles.rejectionTitle}>Rejection Reasons:</h4>
                                <ul className={styles.rejectionList}>
                                    {job.jobId.rejectionReasons.map((reason, index) => (
                                        <li key={index} className={styles.rejectionItem}>
                                            {reason}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
        </>
    );
};

export default AppliedInterns;